import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";

export const routes = {
    [WebRoutes.Dashboard]: {
        path: WebRoutes.Dashboard,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Transactions]: {
        path: WebRoutes.Transactions,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin,
            RoleName.Employee
        ]
    },
    [WebRoutes.TransactionList]: {
        path: WebRoutes.TransactionList,
        roles: [
            RoleName.Mors,
            RoleName.MorsAgent
        ]
    },
    [WebRoutes.Merchants.Index]: {
        path: WebRoutes.Merchants.Index,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin,
            RoleName.Employee
        ]
    },
    [WebRoutes.Merchants.List]: {
        path: WebRoutes.Merchants.List,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin,
            RoleName.Employee
        ]
    },
    [WebRoutes.Merchants.TicketingSystem.Index]: {
        path: WebRoutes.Merchants.TicketingSystem.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.MerchantPayouts]: {
        path: WebRoutes.MerchantPayouts,
        roles: [
            RoleName.Admin,
            RoleName.FinanceAdmin
        ]
    },
    [WebRoutes.Consumers.Index]: {
        path: WebRoutes.Consumers.Index,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin,
            RoleName.Employee
        ]
    },
    [WebRoutes.Consumers.List]: {
        path: WebRoutes.Consumers.List,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.FinanceAdmin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin,
            RoleName.Employee
        ]
    },
    [WebRoutes.Consumers.Blacklisted]: {
        path: WebRoutes.Consumers.Blacklisted,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Consumers.WhiteListed]: {
        path: WebRoutes.Consumers.WhiteListed,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Consumers.Active]: {
        path: WebRoutes.Consumers.Active,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Consumers.ImportHistory.Index]: {
        path: WebRoutes.Consumers.ImportHistory.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Users]: {
        path: WebRoutes.Users,
        roles: [
            RoleName.Admin,
            RoleName.TechAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.QueryBuilder.Index]: {
        path: WebRoutes.QueryBuilder.Index,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.QueryBuilder.EsTransactions]: {
        path: WebRoutes.QueryBuilder.EsTransactions,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.QueryBuilder.EsMerchantPayoutFiles]: {
        path: WebRoutes.QueryBuilder.EsMerchantPayoutFiles,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.Setup.Index]: {
        path: WebRoutes.Setup.Index,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.Setup.PaymentMethodSetup]: {
        path: WebRoutes.Setup.PaymentMethodSetup,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.Setup.GeneralSetup]: {
        path: WebRoutes.Setup.GeneralSetup,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.Index]: {
        path: WebRoutes.OpenBanking.Index,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.BankingSDK]: {
        path: WebRoutes.OpenBanking.BankingSDK,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.IbanXS]: {
        path: WebRoutes.OpenBanking.IbanXS,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.BankingSDKRecipients]: {
        path: WebRoutes.OpenBanking.BankingSDKRecipients,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.BankingSDKConnectorsRecipientsPivots]: {
        path: WebRoutes.OpenBanking.BankingSDKConnectorsRecipientsPivots,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.IbanXSBanksRecipientsPivots]: {
        path: WebRoutes.OpenBanking.IbanXSBanksRecipientsPivots,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.OpenBanking.IbanXSBanksCountriesPivots]: {
        path: WebRoutes.OpenBanking.IbanXSBanksCountriesPivots,
        roles: [
            RoleName.Admin
        ]
    },
    [WebRoutes.Onboarding.Index]: {
        path: WebRoutes.Onboarding.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Onboarding.Applications.Index]: {
        path: WebRoutes.Onboarding.Applications.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Onboarding.Applications.ECommerce]: {
        path: WebRoutes.Onboarding.Applications.ECommerce,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.Onboarding.Applications.HighRisk]: {
        path: WebRoutes.Onboarding.Applications.HighRisk,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin,
            RoleName.OpsSalesAdmin
        ]
    },
    [WebRoutes.KYCSettings.Index]: {
        path: WebRoutes.KYCSettings.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin
        ]
    },
    [WebRoutes.KYCSettings.MerchantKYCSettings.Index]: {
        path: WebRoutes.KYCSettings.MerchantKYCSettings.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin
        ]
    },
    [WebRoutes.KYCSettings.PSPKYCSettings.Index]: {
        path: WebRoutes.KYCSettings.PSPKYCSettings.Index,
        roles: [
            RoleName.Admin,
            RoleName.ComplianceAdmin
        ]
    }
};

export default routes;
